import { fixedUi } from '@/i18n/fixedUi';
import React, { useMemo } from 'react';
import CategoryCascader from '@/temu-platform/components/CategoryCascader';
import { createTemuCategoryChildrenLoader } from '@/temu-platform/utils/temuCategoryLoader';

export default function ShopCategoryPanel({
  loading,
  error,
  categories,
  shopId,
}) {
  const loadChildren = useMemo(
    () => (shopId ? createTemuCategoryChildrenLoader(shopId) : undefined),
    [shopId],
  );

  return (
    <div className="tpo-shop-info__panel" data-testid="temu-category-tree">


      {loading ? <p className="tpo-return-detail__empty">{fixedUi("正在查询商品分类…")}</p> : null}
      {error ? <p className="tpo-shop-info__inline-error" role="alert">{error}</p> : null}

      {!loading && !error ? (
        <div className="tpo-shop-info__category-body">
          <CategoryCascader
            categories={categories}
            loadChildren={loadChildren}
          />
        </div>
      ) : null}
    </div>
  );
}
